import { ColumnDef } from "@tanstack/react-table"
import { DataTableColumnHeader } from "../../shared/table/TableColumnHeader"
import { CustomersTableRowActions } from "./CustomerRowActions"
import { CustomerWithContacts } from "@/database/schema"
import { Contact, Country } from "@/types"
import { Link } from "react-router-dom"

export const customersColumns: ColumnDef<CustomerWithContacts>[] = [
    {
        id: "select",
        header: ({ table }) => (
            <input style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", boxShadow: "none" }}
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => {
                    if (table.getIsAllPageRowsSelected()) {
                        table.toggleAllPageRowsSelected(false);
                    } else {
                        table.toggleAllPageRowsSelected(true);
                    }
                }}
                ref={(input) => {
                    if (input) {
                        input.indeterminate = table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected();
                    }
                }}
                aria-label="Select all"
                type="checkbox"
            />
        ),
        cell: ({ row }) => (
            <input style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", boxShadow: "none" }}
                checked={row.getIsSelected()}
                onChange={(event) => row.toggleSelected(event.target.checked)}
                aria-label="Select row"
                type="checkbox"
            />
        ),
        size: 6,
        minSize: 6,
        enableSorting: false,
        enableHiding: false,
    },
    {
        id: "name",
        accessorKey: "name",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Name" table={table} />
        ),
        cell: ({ row, table }) => {

            return <Link className="table__table-link" onClick={(e) => {
                if (table.getSelectedRowModel().rows.length > 0) return e.preventDefault();
            }} to={{
                pathname: "/history",
                search: `?billto=${row.original.name}`
            }}>
                {row.getValue("name")}
            </Link>
        },
        size: 30,
        enableHiding: false,
    },
    {
        id: "country",
        accessorKey: "country",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Country" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    <span>
                        {(row.getValue("country") as Country).name}
                    </span>
                </div>
            )
        },
        filterFn: (row, _id, value) => {
            return value.some((item: string) => item === row.original.country.name)
        },
        size: 30,
        enableSorting: false
    },
    {
        id: "contacts",
        accessorKey: "activeContacts",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Contacts" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    <span>
                        {(row.getValue("contacts") as Contact[]).length}
                    </span>
                </div>
            )
        },
        size: 30
    },
    {
        id: "actions",
        size: 4,
        minSize: 4,
        cell: ({ row, table }) => <CustomersTableRowActions row={row} table={table} />,
    },
]

